module.exports = __webpack_public_path__ + "static/img/icon_first.3ce1f681.png";